module.exports = __webpack_public_path__ + "img/4.96c43f91.png";